import * as Const from '../constants/actionConstants';

import ChangeToasterMessage from '../interfaces/actions/ChangeToasterMessage';
import RemoveToasterMessage from '../interfaces/actions/RemoveToasterMessage';
import ChangeTokenUpdateStatus from '../interfaces/actions/ChangeTokenUpdateStatus';

export const changeToasterMessage = (content: string, type: string, id: string): ChangeToasterMessage => {
  return {
    type: Const.TOASTER_ADD_MESSAGE,
    message: {
      content,
      type,
      id,
    },
  };
};

export const removeToasterMessage = (id: string): RemoveToasterMessage => {
  return {
    type: Const.TOASTER_DELETE_MESSAGE,
    id,
  };
};

export const changeTokenUpdateStatus = (status: boolean): ChangeTokenUpdateStatus => {
  return {
    type: Const.TOASTER_TOKEN_IS_UPDATING,
    status,
  };
};
